exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"addserviceupdatemodal.scss","sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/addServiceUpdateModal/addserviceupdatemodal.scss
// module id = 1050
// module chunks = 0